import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SubmitButtonClickService {

  private submitButtonStatus = new Subject<string>();
  private submitButtonSuccess = new Subject<string>();
  private disableForm = new Subject<string>();
  private enableForm = new Subject<string>();

  public setSubmitButtonClick(title:string) {
    this.submitButtonStatus.next(title);
  }

  public getSubmitButtonClick(): Observable<string> {
    return this.submitButtonStatus.asObservable();
  }

  public setSubmitButtonSuccess(title:string) {
    this.submitButtonSuccess.next(title);
  }

  public getSubmitButtonSuccess(): Observable<string> {
    return this.submitButtonSuccess.asObservable();
  }

  public setDisableFormSuccess(title:string) {
    this.disableForm.next(title);
  }

  public getDisableFormSuccess(): Observable<string> {
    return this.disableForm.asObservable();
  }

  public setEnableFormSuccess(title:string) {
    this.enableForm.next(title);
  }

  public getEnableFormSuccess(): Observable<string> {
    return this.enableForm.asObservable();
  }
  
}
